import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import BaseDataTable from "../../../components/modules/BaseDataTable";
import Select from "../../../components/elements/Select";
import classes from "./AdvertiserDetailsSection.module.scss";
import { AdvertiserType } from "../../../types/advertiserTypes";
import { SelectOptionType } from "../../../components/elements/Select/Select";
import { truncateText } from "../../../helpers/truncateText";

type AdvertiserBasicDetailsProps = {
  advertisers: AdvertiserType[];
  advertiser: AdvertiserType;
};

const AdvertiserBasicDetails: FC<AdvertiserBasicDetailsProps> = ({ advertiser, advertisers }) => {
  const options: SelectOptionType[] = advertisers.map(({ name, brandgenAdvertiserId }) => ({
    label: name,
    value: brandgenAdvertiserId,
  }));

  const columns = [
    { key: "brandgenAdvertiserId", label: "BrandGen AdvertiserId", minWidth: 170 },
    { key: "createdBy", label: "Created by", minWidth: 150 },
    { key: "domain", label: "Domain", minWidth: 150 },
    { key: "address", label: "Address", minWidth: 150 },
    { key: "phoneNumber", label: "Phone Number", minWidth: 150 },
    // { key: "burnRate", label: "Burn Rate", minWidth: 150 },
  ] as const;

  const history = useHistory();

  const rows = [
    {
      id: advertiser.brandgenAdvertiserId,
      brandgenAdvertiserId: (() => (
        <Typography className={classes.dashboardLongTextInfo}>{advertiser.brandgenAdvertiserId}</Typography>
      ))(),
      createdBy: advertiser.createdBy,
      domain: (() =>
        advertiser.domain ? (
          <a
            href={advertiser.domain}
            target="_blank"
            className={classes.dashboardLongTextInfo}
            rel="noopener noreferrer"
          >
            {advertiser.domain}
          </a>
        ) : null)(),
      address: (() => (
        <>
          <Typography className={classes.dashboardLongTextInfo}>{`Address 1: ${advertiser.address_1}.`}</Typography>

          {advertiser.address_2 ? (
            <>
              <Typography className={classes.dashboardLongTextInfo}>{`Address 2: ${advertiser.address_2}.`}</Typography>
            </>
          ) : null}
        </>
      ))(),
      phoneNumber: advertiser.phone ?? "None",
      // burnRate: `$${advertiser.advertiser_burn_rate?.toFixed(2)}`,
    },
  ];

  const handleChangeAdvertiserDetailToView = (e: any) => {
    const brandgenAdvertiserId = (e.target as HTMLSelectElement).value;
    history.replace({
      pathname: `/advertisers/${brandgenAdvertiserId}`,
      search: "",
    });
  };

  return (
    <div className={classes.advertiserBasicDetails}>
      <div className={classes.advertiserBasicDetailsHead}>
        <Tooltip title={advertiser.name}>
          <Typography variant="h2">{truncateText(advertiser.name, 36)}</Typography>
        </Tooltip>

        <div className={classes.selector}>
          <Select
            className={classes.select}
            label={null}
            options={options}
            value={advertiser.brandgenAdvertiserId}
            onChange={handleChangeAdvertiserDetailToView}
          />
        </div>
      </div>

      <div className={classes.dashboard}>
        <BaseDataTable columns={columns} rows={rows} />
      </div>
    </div>
  );
};

export default AdvertiserBasicDetails;
